var _module_exports = "  <footer class=\"webapp-footer\">\n    <div class=\"container\">\n      <div class=\"webapp-footer__body\">\n          <div class=\"left\">\n              <p class=\"webapp-footer__rights\">&copy; greenback 2023 All Rights Reserved</p>\n          </div>\n          <div class=\"right text-right\">\n            <a ui-sref=\"terms.web\" target=\"_blank\" class=\"webapp-footer__link\">Terms & Conditions</a>\n          </div>\n      </div>\n    </div>\n  </footer>\n";;
var path = '/containers/core/views/elements/feet.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./js/containers/core/views/elements/feet.html
// module id = 708
// module chunks = 0